import service from "@publicrelay/service";
import getBaseUrl from "../api/baseUrl";

export const debug = !(window.thisEnvironmentType === "PROD");

export const baseUrl = getBaseUrl(debug);

/**
 * Initiate a GET request
 * @param {string} url
 * @param {*} [options]
 * @returns {Promise<Response>}
 */
export function get(url, options = {}) {
    return service.get(url, options, baseUrl);
}

/**
 * Import all of service
 */
export default {
    get,
};
